import type {
  IProgram,
  IProgramId,
  IProgramInteraction,
  IProgramInteractionId} from '@app/domain/program/program.interface';
import {
  RequestStatusId,
} from '@app/domain/program/program.interface'
import type { AppAction } from '@app/state'

export interface State {
  currentInteraction: IProgramInteraction
  currentInteractionType: IProgramInteractionId
  loadedProgram: IProgram
  isEditInteractionModalOpen: boolean
  updateProgramErrorMessage: string
  updateProgramStatus: RequestStatusId
}

export const initialState: State = {
  currentInteraction: undefined,
  currentInteractionType: undefined,
  loadedProgram: undefined,
  isEditInteractionModalOpen: false,
  updateProgramErrorMessage: '',
  updateProgramStatus: RequestStatusId.Unsubmitted,
}

export enum ActionType {
  AddInteractionToProgram = 'PROGRAM_SCREEN/ADD_INTITAL_TO_PROGRAM',
  AddInteractionToProgramFailed = 'PROGRAM_SCREEN/ADD_INTITAL_TO_PROGRAM/FAILED',
  AddInteractionToProgramSucceeded = 'PROGRAM_SCREEN/ADD_INTITAL_TO_PROGRAM/SUCCEEDED',
  DeleteProgramInteraction = 'PROGRAM_SCREEN/DELETE_PROGRAM_INTERACTION',
  UpdateProgramInteraction = 'PROGRAM_SCREEN/UPDATE_PROGRAM_INTERACTION',
  UpdateProgramInteractionFailed = 'PROGRAM_SCREEN/UPDATE_PROGRAM_INTERACTION/FAILED',
  UpdateProgramInteractionSucceeded = 'PROGRAM_SCREEN/UPDATE_PROGRAM_INTERACTION/SUCCEEDED',
  UpdateProgramInteractionProperties = 'PROGRAM_SCREEN/UPDATE_PROGRAM_INTERACTION_PROPERTIES',
  UpdateProgramInteractionPropertiesFailed = 'PROGRAM_SCREEN/UPDATE_PROGRAM_INTERACTION_PROPERTIES/FAILED',
  UpdateProgramInteractionPropertiesSucceeded = 'PROGRAM_SCREEN/UPDATE_PROGRAM_INTERACTION_PROPERTIES/SUCCEEDED',
  UpdateProgram = 'PROGRAM/UPDATE',
  UpdateProgramSucceeded = 'PROGRAM/UPDATE/SUCCEEDED',
  UpdateProgramFailed = 'PROGRAM/UPDATE/FAILED',
  LoadProgram = 'PROGRAM_SCREEN/LOAD',
  LoadProgramSucceeded = 'PROGRAM_SCREEN/LOAD/SUCCEEDED',
  LoadProgramFailed = 'PROGRAM_SCREEN/LOAD/FAILED',
  UpdateLoadedProgram = 'PROGRAM_SCREEN/UPDATE_LOADED_PROGRAM',
  OpenEditInteractionModal = 'PROGRAM_SCREEN/EDIT_INTERACTION_MODAL/OPEN',
  CloseEditInteractionModal = 'PROGRAM_SCREEN/EDIT_INTERACTION_MODAL/CLOSE',
}

export type Action =
  | { type: ActionType.UpdateProgram; program: IProgram }
  | { type: ActionType.UpdateProgramSucceeded; program: IProgram }
  | { type: ActionType.UpdateProgramFailed; errorMessage: string }
  | { type: ActionType.LoadProgram; programId: IProgramId }
  | { type: ActionType.LoadProgramSucceeded; program: IProgram }
  | { type: ActionType.UpdateLoadedProgram; program: IProgram }

export const actions = {
  updateProgram(program: IProgram) {
    return { type: ActionType.UpdateProgram, program }
  },
  updateProgramSucceeded(program: IProgram) {
    return { type: ActionType.UpdateProgramSucceeded, program }
  },
  updateProgramFailed(errorMessage: string) {
    return { type: ActionType.UpdateProgramFailed, errorMessage }
  },
  loadProgram(programId: IProgramId) {
    return { type: ActionType.LoadProgram, programId }
  },
  loadProgramSucceeded(program: IProgram) {
    return { type: ActionType.LoadProgramSucceeded, program }
  },
  loadProgramFailed() {
    return { type: ActionType.LoadProgramFailed }
  },
  updateLoadedProgram(program: IProgram) {
    return { type: ActionType.UpdateLoadedProgram, program }
  },
}

export function reducer(state: State = initialState, action: AppAction): State {
  switch (action.type) {
    case ActionType.LoadProgramSucceeded:
    case ActionType.UpdateLoadedProgram:
      return {
        ...state,
        loadedProgram: action.program,
      }

    case ActionType.UpdateProgramSucceeded:
      return {
        ...state,
        loadedProgram: action.program,
        updateProgramStatus: RequestStatusId.Success,
        updateProgramErrorMessage: '',
      }

    case ActionType.UpdateProgramFailed:
      return {
        ...state,
        updateProgramStatus: RequestStatusId.Error,
        updateProgramErrorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
